<div *ngIf="electricMobility$ | async as mobility">
    <div class="desktop edp-card-widget card cursor-pointer" (click)="goToMobilityPage()">
        <div class="card-header flex-column align-items-start">
            <div class="d-flex">
                <span class="card-title">{{ "pt.edp.edponline.mobility.card.title" | translate }}</span>
                <span class="card-icon">
                    <i class="icon-edponline-Bop-023" aria-hidden="true"></i>
                </span>
            </div>
            <span class="edp-widget-mobility__period">
                {{ "pt.edp.edponline.general.from" | translate }}
                <b>{{ (mobility.start | date: "dd MMM" | titlecase).slice(0, -1) }}</b>
                {{ "pt.edp.edponline.general.to" | translate }}
                <b>{{ (mobility.end | date: "dd MMM" | titlecase).slice(0, -1) }}</b>
            </span>
        </div>

        <div class="card-body edp-widget-mobility__body">
            <div class="d-flex justify-content-between align-items-start">
                <div class="d-flex flex-column">
                    <span class="edp-widget-mobility__value" [innerHTML]="mobility.value | edpDecimalSplit: ',':'kWh'"></span>
                    <span class="edp-widget-mobility__charges">
                        <span class="edp-widget-mobility__charges__amount">{{ mobility.totalCharges }}</span>
                        <span>{{ "pt.edp.edponline.mobility.charges" | translate }}</span>
                    </span>
                </div>
                <i class="icon-edponline-Bra-048 edp-widget-mobility__icon"></i>
            </div>
        </div>
    </div>

    <div class="mobile edp-card-widget card cursor-pointer" (click)="goToMobilityPage()">
        <div class="card-header flex-column align-items-start">
            <div class="d-flex justify-content-between align-items-center w-100">
                <span class="card-title-small">{{ "pt.edp.edponline.mobility.card.title" | translate }}</span>
                <span class="card-icon">
                    <i class="icon-edponline-Bop-023" aria-hidden="true"></i>
                </span>
            </div>
            <span class="edp-widget-mobility__period">
                {{ "pt.edp.edponline.general.from" | translate }}
                <b>{{ (mobility.start | date: "dd MMM" | titlecase).slice(0, -1) }}</b>
                {{ "pt.edp.edponline.general.to" | translate }}
                <b>{{ (mobility.end | date: "dd MMM" | titlecase).slice(0, -1) }}</b>
            </span>
        </div>
        <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
                <div class="d-flex align-items-center">
                    <i class="icon-edponline-Bra-048 edp-widget-mobility__icon"></i>
                    <span class="edp-widget-mobility__value" [innerHTML]="mobility.value | edpDecimalSplit: ',':'kWh'"></span>
                </div>
                <span class="edp-widget-mobility__charges">
                    <span class="edp-widget-mobility__charges__amount">{{ mobility.totalCharges }}</span>
                    <span>{{ "pt.edp.edponline.mobility.charges" | translate }}</span>
                </span>
            </div>
        </div>
    </div>
</div>
